import {
  sendRequest,
} from 'utils/httpClient';
import {
  RealTimeGetRemoteSdpRequest,
} from 'views/EMR/components/AIAssistant/hooks';

const model = 'gpt-4o-realtime-preview-2024-12-17';

const getRemoteSdp = async ({
  localSdp,
  realTimeToken,
}: RealTimeGetRemoteSdpRequest): Promise<string> => sendRequest<string>({
  url: `https://api.openai.com/v1/realtime?model=${model}`,
  method: 'POST',
  data: localSdp,
  headers: {
    Authorization: `Bearer ${realTimeToken}`,
    'Content-Type': 'application/sdp',
  },
});

export default getRemoteSdp;
